import { UploadedFile } from '../files/UploadedFile';

export function findFileByName(files: readonly UploadedFile[], filename: string, extension?: string) {
  return files.find((file) => {
    if (extension && file.filetype && file.filetype.toLowerCase() !== extension) {
      return false;
    }

    return sanitizeZipFilename(file.filename) === filename.toLowerCase();
  });
}

export function findFileByExtension(files: readonly UploadedFile[], extension: string) {
  return files.find((file) => file.filetype != null && file.filetype.toLowerCase() === extension.toLowerCase());
}

export function findAllFilesWithExtension(files: readonly UploadedFile[], extension: string) {
  return files.filter((file) => file.filetype && file.filetype.toLowerCase() === extension);
}

export function hasFilesWithExtension(files: readonly UploadedFile[], extension: string) {
  return findFileByExtension(files, extension) != null;
}

export function isMiTekJob(files: readonly UploadedFile[]) {
  return hasFilesWithExtension(files, 'tre');
}

export function isAlpineJob(files: readonly UploadedFile[]) {
  return hasFilesWithExtension(files, 'of');
}

export function isSimpsonJob(files: readonly UploadedFile[]) {
  return hasFilesWithExtension(files, 'tdlTruss');
}

export function isMiTekJobComponent(entry: UploadedFile) {
  const filetype = (entry.filetype || '').toLowerCase();
  return filetype === 'pdf' || filetype === 'tre' || filetype === 'ans' || filetype === 'dxf';
}

export function isSimpsonJobComponent(entry: UploadedFile) {
  const filetype = (entry.filetype || '').toLowerCase();
  return filetype === 'pdf' || filetype === 'tdltruss';
}

function sanitizeZipFilename(fileName: string) {
  let sanitizedFileName = fileName;
  if (fileName.includes('/')) {
    const fileNameParts = fileName.split('/');
    sanitizedFileName = fileNameParts[fileNameParts.length - 1];
  }

  return sanitizedFileName.toLowerCase();
}
